import { motion } from "framer-motion";
import { Gem, Leaf, Heart, Clock } from "lucide-react";
const features = [{
  icon: Gem,
  title: "Premium Quality",
  description: "Luxurious formulas crafted with the finest ingredients your skin deserves."
}, {
  icon: Leaf,
  title: "Cruelty Free",
  description: "Cruelty-free formulas free from harmful chemicals and toxins never tested on animals."
}, {
  icon: Heart,
  title: "Made with Love",
  description: "Every product is thoughtfully designed to enhance your natural beauty and boost confidence."
}, {
  icon: Clock,
  title: "Long-Lasting",
  description: "All-day wear that keeps you looking flawless from morning to night."
}];
const BrandStory = () => {
  return <section id="brand-story" className="py-24 bg-card relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />

      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: -40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} viewport={{
          once: true
        }}>
            <h2 className="font-display text-4xl md:text-5xl font-semibold text-foreground mb-6">
              Beauty That
              <br />
              <span className="text-primary glow-text">Speaks Volumes</span>
            </h2>

            <p className="text-muted-foreground mb-8 leading-relaxed text-xl font-subtitle">True beauty starts from within. We create cosmetics that don't just enhance; they empower.</p>

            <p className="text-muted-foreground mb-8 leading-relaxed text-lg font-subtitle">
              Premium ingredients. Exceptional results. Every product is crafted to celebrate your unique essence.
            </p>

            <div className="flex items-center gap-4">
              <div className="h-px flex-1 bg-border" />
              <span className="font-display text-sm text-primary tracking-widest">SINCE 2025</span>
              <div className="h-px flex-1 bg-border" />
            </div>
          </motion.div>

          {/* Features Grid */}
          <motion.div initial={{
          opacity: 0,
          x: 40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} viewport={{
          once: true
        }} className="grid grid-cols-2 gap-6">
            {features.map((feature, index) => <motion.div key={feature.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} whileHover={{
            y: -8,
            transition: { duration: 0.15, ease: "easeOut" }
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} viewport={{
            once: true
          }} className="group p-6 rounded-2xl bg-background border border-border/50 hover:border-primary/30 transition-all duration-300 hover:shadow-[0_0_30px_hsl(350,100%,88%,0.1)]">
                <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors">
                  <feature.icon className="w-6 h-6 text-primary" />
                </div>
                <h3 className="font-display text-lg font-medium text-foreground mb-2">
                  {feature.title}
                </h3>
                <p className="font-subtitle text-sm text-muted-foreground">
                  {feature.description}
                </p>
              </motion.div>)}
          </motion.div>
        </div>
      </div>
    </section>;
};
export default BrandStory;